import { tick } from 'svelte';
import { get } from 'svelte/store';

import { JUMP_TYPE_ENUM } from '../enums';
import { TechBtnId } from '../enums/track';
import { isJumpOneLink, pageId, startTime } from '../store/index';

import { getOnelinkUrl } from './onelink';
import { trackEvent } from './track';

import { getH5creditCardBaseUrl } from '@/utils/getH5cardLink';
import url from '@/utils/url';

export const getH5CreditCardUrl = (
    params: Record<string, string | number> = {}
) => {
    const baseUrl = getH5creditCardBaseUrl();
    const resource = url.get('resource') || window.adv?.getChannelEnv();
    const parseQuery = url.pureParseQuery();

    return url.buildUrl(baseUrl, {
        ...parseQuery,
        resource,
        pageId: get(pageId),
        fromPage: 'web2app',
        fromPageId: window?.__PAGE_CONFIG__?.trackingPageId || '',
        ...params
    });
};

export const JumpLink = async (jumpType = JUMP_TYPE_ENUM.TO_H5CREDITCARD) => {
    try {
        isJumpOneLink.set(true);
        await tick();

        if (jumpType === JUMP_TYPE_ENUM.TO_H5CREDITCARD) {
            const link = getH5CreditCardUrl();

            if (link) {
                trackEvent(TechBtnId.JUMP, { url_type: 'creditcard' });
                trackEvent('fin_credit_abroad_apply_bureau_time_sw', {
                    stay_time: Date.now() - get(startTime)
                });
                const preloader = window.preloader as {
                    shouldShowIframe?: () => boolean;
                    showIframe?: () => boolean;
                };

                if (
                    preloader?.shouldShowIframe?.() &&
                    preloader.showIframe?.()
                ) {
                    console.log('预加载');

                    return;
                }

                console.log('跳转');
                window.location.href = link;
            }
        } else {
            const link = getOnelinkUrl();

            trackEvent(TechBtnId.JUMP, { url_type: 'onelink' });

            if (link) {
                window.location.href = link;
            }
        }
    } catch (error) {
        console.error('JumpLink error:', error);
    }
};

export const jumpToOnelink = async () => {
    await JumpLink(JUMP_TYPE_ENUM.TO_WEB2APP);
};
